/* eslint-disable max-len */
import { useTranslation } from 'react-i18next';
import { ManageOrderCodeLabelColumn } from '../../../../components';

export interface ManageAlterationsTableHeadProps {
  columns: ManageOrderCodeLabelColumn[];
};

export const ManageAlterationsTableHead = (props: ManageAlterationsTableHeadProps) => {
  const { t } = useTranslation();
  return (
    <thead>
      <tr>
        {
          props.columns.map((col) => (
            <th
              key={`head-${col.id}`}
              style={{ width: col.maxWidth }}
            >
              {t(col.label).toUpperCase()}
            </th>
          ))
        }
      </tr>
    </thead>
  );
};
